/** 아이콘은 인라인 스트로크 SVG 로만 둔다 — 이모지를 쓰지 않는다. */
const paths = {
  back: <path d="M15 5l-7 7 7 7" />,
  next: <path d="M9 5l7 7-7 7" />,
  arrow: <><path d="M5 12h14" /><path d="M13 6l6 6-6 6" /></>,
  close: <path d="M6 6l12 12M18 6L6 18" />,
  check: <path d="M5 12l5 5 9-10" />,
  warn: <><path d="M12 8v5" /><path d="M12 17h.01" /><circle cx="12" cy="12" r="9" /></>,
  info: <><circle cx="12" cy="12" r="9" /><path d="M12 8h.01" /><path d="M11 12h1v4h1" /></>,
  retry: <><path d="M20 11a8 8 0 10-2.3 5.7" /><path d="M20 5v6h-6" /></>,
  clock: <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>,
  list: <><path d="M4 7h16" /><path d="M4 12h16" /><path d="M4 17h10" /></>,
  mail: <><rect x="3" y="5.5" width="18" height="13" rx="2.5" /><path d="M3.8 7.6L12 13.2l8.2-5.6" /></>,
};

export default function Icon({ name, size = 20, stroke = "currentColor", width = 2.6 }) {
  return (
    <svg
      aria-hidden="true" width={size} height={size} viewBox="0 0 24 24"
      fill="none" stroke={stroke} strokeWidth={width}
      strokeLinecap="round" strokeLinejoin="round"
    >
      {paths[name]}
    </svg>
  );
}
